<template>
  <a-card title="角色管理"
          :bordered="false"
          style="width: 100%;height:100%;overflow:hidden">
    <template #extra>
      <a-checkbox v-model:checked="selectChoose">多选</a-checkbox>
      <a-button @click="freshData">刷新</a-button>
      <a-button v-p="'/authorizations/roles:POST'"
                @click="createRole">创建角色</a-button>
      <a-popconfirm title="是否确定删除选中的角色"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="deleteConfirm">
        <a-button v-p="'/authorizations/roles/:id?'">删除</a-button>
      </a-popconfirm>
    </template>
    <div class="scroll-table">
      <a-scroll-table :dataSource="dataSource"
                      class="scroll"
                      rowKey="id"
                      :columns="columns"
                      :customRow="customRowFn"
                      :loading="loading"
                      :pagination="false"
                      :rowSelection="{ selectedRowKeys: selectedRow, onChange: onSelectChange, type: !selectChoose ? 'radio' : 'checkbox' }">
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'name'">
            <div class="editable-cell">
              <div class="editable-cell-text-wrapper">
                {{ text }}
              </div>
            </div>
          </template>
          <template v-else-if="column.dataIndex === 'operation'">
            <a @click="editRow(record)"
               v-p="`/authorizations/roles/:id:PUT`">编辑</a>
            <a @click="deleteRow(record)"
               v-p="`/authorizations/roles/:id?:DELETE`"
               style="margin-left:10px">删除</a>
          </template>
        </template>
      </a-scroll-table>
    </div>
    <a-modal v-model:visible="createRoleVisible"
             title="新建"
             :confirm-loading="confirmLoading"
             @ok="createRoleConfirm">
      <a-form :model="createRoleForm"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 24 }">
        <a-form-item label="名称"
                     name="name"
                     :rules="[{ required: true, message: '请输入名称  支持1-40位非空格字符' }]">
          <a-input v-model:value="createRoleForm.name" />
        </a-form-item>
        <a-form-item label="描述"
                     name="description">
          <a-textarea v-model:value="createRoleForm.desc"
                      :auto-size="{ minRows: 5 }" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal v-model:visible="deleteRoleVisible"
             title="删除"
             :confirm-loading="confirmLoading"
             @ok="deleteRoleConfirm">
      <p style="font-size:16px">是否删除角色：<span style="color:red">{{ deleteRoleForm.name }}</span></p>
    </a-modal>
  </a-card>
</template>

<script setup lang="ts">
import type { RbacRoleState } from '@/plugins'
import { AScrollTable } from '@iota-cn/ui-components'
import { message } from 'ant-design-vue'
import { assign, remove } from 'lodash'
import { container } from 'tsyringe'
import { onMounted, reactive, ref } from 'vue'
import { CORE_AXIOS, Http } from '../../../../../core'
import { useRbacStore } from '../../DefaultRbacPagePlugin'
const axios = container.resolve<Http>(CORE_AXIOS)
const rbac = useRbacStore()
const selectedRow: Array<string> = reactive([])
const createRoleForm = reactive<Partial<RbacRoleState>>({})
const deleteRoleForm = reactive<Partial<RbacRoleState>>({})
const selectChoose = ref<boolean>(false)
const loading = ref<boolean>(false)
const createRoleVisible = ref<boolean>(false)
const deleteRoleVisible = ref<boolean>(false)
const confirmLoading = ref<boolean>(false)
const dataSource = reactive<Array<RbacRoleState>>([])

onMounted(() => {
  freshData()
})

//表格有两种点击响应逻辑，点击多选框/单选框 和 点击一列
// 多选/单选 选中后的操作逻辑
const onSelectChange = (keys: string) => {
  remove(selectedRow)
  selectedRow.push(...keys)
  selectedRow.forEach(id => {
    rbac.$patch(state => {
      state.models.role = [dataSource.find(item => item.id == id) as RbacRoleState]
    })
  })
}

//表格 选择列 单选/多选 操作逻辑
const customRowFn = (record: RbacRoleState) => {
  return {
    onClick: () => {
      //判断为单选情况
      if (!selectChoose.value) {
        remove(selectedRow)
        selectedRow.push(record.id)
        rbac.$patch(state => {
          state.models.role = [record]
        })
      }
      //判断为多选的情况
      else {
        if (!selectedRow.find(item => item == record.id)) {
          selectedRow.push(record.id)

        } else {
          selectedRow.forEach((item, index) => {
            if (item == record.id) {
              selectedRow.splice(index, 1)

            }
          })
        }
      }
    }
  }
}

//refresh TableData Func
const freshData = () => {
  axios.get('/v1/api/authorizations/roles').then(result => {
    const { roles = [] } = result as { roles: RbacRoleState[] }
    dataSource.length = 0
    dataSource.push(...roles)
  })
}

//删除 Func
const deleteConfirm = () => {
  const idArray = selectedRow.join(',')
  axios.delete('/v1/api/authorizations/roles?ids=' + idArray, { ids: idArray }).then(() => {
    message.success('删除成功')
    freshData()
  })
}

//创建角色 Func
const createRole = () => {
  createRoleVisible.value = true
  assign(createRoleForm, { name: '', desc: '', id: '' })
}

//创建角色/编辑角色 确认 Func
const createRoleConfirm = () => {
  const { name, desc, id } = createRoleForm
  confirmLoading.value = true
  if (id) {
    axios.put("/v1/api/authorizations/roles/" + id, { name, desc }).then(() => {
      message.success('修改成功')
      createRoleVisible.value = false
      confirmLoading.value = false
      freshData()
    })
  } else {
    axios.post("/v1/api/authorizations/roles", { name, desc }).then(() => {
      message.success('创建成功')
      createRoleVisible.value = false
      confirmLoading.value = false
      freshData()
    })
  }
}

//删除角色 确认 Func
const deleteRoleConfirm = () => {
  const { id } = deleteRoleForm
  axios.delete("/v1/api/authorizations/roles?ids=" + id).then(() => {
    message.success('删除成功')
    deleteRoleVisible.value = false
    confirmLoading.value = false
    freshData()
  })
}

//编辑数据
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const editRow = (rowData: any) => {
  assign(createRoleForm, rowData)
  createRoleVisible.value = true
}
//删除数据
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const deleteRow = (rowData: any) => {
  assign(deleteRoleForm, rowData)
  deleteRoleVisible.value = true
}

const columns = ref([
  {
    title: '名称',
    dataIndex: 'name',
    key: 'name',
    width: 100
  },
  {
    title: '描述',
    dataIndex: 'desc',
    key: 'desc',
    width: 130
  },
  {
    title: '创建时间',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 200
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    width: 135
  }
])
</script>

<style lang="less" scoped>
:deep(.ant-card-body) {
  height: 91%;
  display: flex;
  overflow-y: auto
}

:deep(.ant-table-tbody) {
  tr>td {
    word-wrap: break-word;
    white-space: pre;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}

.scroll-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;

  .scroll {
    flex: 1;
    overflow: hidden
  }
}
</style>
